import React, { useState, useEffect } from "react";
import Icon from "@gc-npm/components.icon-glyph";
import { COLOR_DICTIONARY } from "@gc-npm/utils.enums.colors";


const ChevronIcon = ({ open }) => {
  return (
    <div>
      <Icon
        id={open ? "cheuron-up-m" : "cheuron-down-m"}
        color={COLOR_DICTIONARY.MOVISTAR_BLUE}
        width={20}
      />
    </div>
  );
};

export default ChevronIcon;
